import { useDealRoomContext } from 'features/pages/marketplace/DealRoomContext';
import { isNotNullOrUndefined } from 'utils/typeUtils';

import { useQuery } from '@apollo/client';

import { GetCollateralNotes, GetCollateralNotesVariables } from 'query/__generated__/collateral';
import { GET_COLLATERAL_NOTES } from 'query/collateral';

type CollateralNotesType = NonNullable<
  NonNullable<
    NonNullable<NonNullable<NonNullable<GetCollateralNotes>['collateralNotes']>['files']>[number]
  >['notes']
>[number];
export const useCollateralNotesForFile = (
  dealID: string,
  loanID: string,
  fileName: string,
  pollWhileDialogOpen = false,
) => {
  const { isDocumentSelectedForView } = useDealRoomContext();
  const shouldPollNotes = isDocumentSelectedForView || pollWhileDialogOpen;
  const { data, loading, refetch } = useQuery<GetCollateralNotes, GetCollateralNotesVariables>(
    GET_COLLATERAL_NOTES,
    {
      variables: { dealID, loanID, fileName },
      fetchPolicy: 'cache-and-network',
      pollInterval: shouldPollNotes ? 10_000 : 0,
    },
  );

  const notes =
    data?.collateralNotes?.files?.flatMap((file) => file?.notes)?.filter(isNotNullOrUndefined) ||
    [];

  return { notes, loading, refetch };
};

export const useCollateralNotesForDeal = (dealID: string) => {
  const { data, loading, error } = useQuery<GetCollateralNotes, GetCollateralNotesVariables>(
    GET_COLLATERAL_NOTES,
    {
      variables: { dealID },
      fetchPolicy: 'cache-and-network',
      skip: !dealID,
    },
  );

  const notes =
    data?.collateralNotes?.files
      ?.flatMap(
        (file) =>
          file?.notes?.map((note) => ({
            ...note,
            collateralID: file.file.collateralID,
          })) || [],
      )
      .filter(
        (note): note is CollateralNotesType & { collateralID: string | null } => note !== null,
      ) || [];

  const notesMap = notes.reduce<Record<string, boolean>>((map, note) => {
    if (note.collateralID) {
      map[note.collateralID] = true;
    }
    return map;
  }, {});

  return { notes, notesMap, loading, error };
};
